// extracted by mini-css-extract-plugin
module.exports = {"CatsDetails":"CatsDetails_CatsDetails__AwqzY"};